/**
 * KeyText component.
 */
import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const KeyText = styled.div<Props>`
  cursor: pointer;
  font-family: ${Fonts['regular']};
  font-size: ${24 * Screen.widthRatio}px;
  color: ${(props) => (props.focused ? 'black' : Colors['grey'])};
  margin-right: ${5 * Screen.widthRatio}px;
  float: left;
  width: ${36 * Screen.widthRatio}px;
  height: ${43 * Screen.widthRatio}px;
  text-align: center;
  line-height: ${44 * Screen.widthRatio}px;
  float: left;
  border-radius: ${5 * Screen.widthRatio}px;
  background-color: ${(props) =>
    props.focused ? Colors['key'] : Colors['keyBg']};
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.3);
  margin-bottom: ${4 * Screen.widthRatio}px;
  position: relative;
`;

export default KeyText;
